export default "<p style=\"height: 70vh;\">Redirecting...</p>"